<template>
  <v-layout v-resize="onResize" column style="padding-top: 56px">
    <div class="content">
      <div class="container-fluid">
        <div class="row" style="margin-top: 20px">
          <div class="col-md-6" style="float: right">
            <v-card class="mx-auto" max-width="344" outlined>
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title
                    class="text-h5 mb-1"
                    style="color: gray; height: 50px"
                  >
                    TOTAL TAO YU
                  </v-list-item-title>
                  <v-list-item-title class="text-h3 mb-1">
                    {{user.Taoyu}}
                  </v-list-item-title>
                  <v-list-item-subtitle>Seluruh Kota</v-list-item-subtitle>
                </v-list-item-content>

                <v-avatar
                  size="50px"
                  v-ripple
                  class="lighten-3 mb-3"
                  color="#FFB74D"
                >
                  <v-icon dark> mdi-account </v-icon>
                </v-avatar>
              </v-list-item>
            </v-card>
          </div>

          <div class="col-md-6" style="">
            <v-card class="mx-auto" max-width="344" outlined>
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title
                    class="text-h5 mb-1"
                    style="color: gray; height: 50px"
                  >
                    TOTAL HUANG YI
                  </v-list-item-title>
                  <v-list-item-title class="text-h3 mb-1">
                    {{user.Huangyi}}
                  </v-list-item-title>
                  <v-list-item-subtitle>Seluruh Kota</v-list-item-subtitle>
                </v-list-item-content>

                <v-avatar
                  size="50px"
                  v-ripple
                  class="lighten-3 mb-3"
                  color="#EF6C00"
                >
                  <v-icon dark> mdi-account-alert </v-icon>
                </v-avatar>
              </v-list-item>
            </v-card>
          </div>
        </div>
        <div class="row" style="padding: 20px; margin: 10px">
          <v-card class="chart_dash">
            <div style="text-align: center; margin-bottom: 20px">
              <h2>Total Tao Yu dan Huang Yi Seluruh Kota</h2>
            </div>
            <div style="padding: 40px">
              <apexchart
                width="100%"
                height="200%"
                type="bar"
                :options="options"
                :series="series"
              ></apexchart>
            </div>
          </v-card>
        </div>
      </div>
    </div>
    <!-- <div class="container-fluid" style="align-items: center;align-content: center;">
	<div class="row">
		<div class="col" style="float: right">ABC</div>
		<div class="col" style="float: right">ABC</div>
		<div class="col">B</div>
	</div>
	<div class="row" style="padding:20px;margin:10px;">
	</div>
</div> -->
  </v-layout>
</template>

<script type="text/javascript">
import VueApexCharts from 'vue-apexcharts'
import axios from '@/axios'
export default {
	data: () => ({
		user: {
	        Taoyu: 0,
	        Huangyi: 0,
	        Chart: null,
	    },
		options: {
	        chart: {
	          	id: 'vuechart-example',
	        },
	        xaxis: {
	          categories: []
	        },
	      	colors:['#FFB74D', '#EF6C00'],
	    },
	  isMobile: false,
    series: [
      	{
        	name: 'Taoyu',
        	data: [30, 40, 45, 50, 49, 60, 70, 91]
      	},{
        	name: 'Huangyi',
        	data: [30, 40, 50, 55, 20, 100, 70, 39]
      	}],
	}),
	mounted:function(){
		// alert('Hai');
		if(this.$session.get('token')){
			axios({
	            method: 'get',
	            url: 'dashboard',
	            headers: {
	              Authorization: 'Bearer ' + this.$session.get('token'),
	            },
	        }).then(response => {
	        	
	        	this.options = {
	        		xaxis:{
	        			categories: response.data.daftar_kota.map(kota => kota.KOTA_TAOYING)
	        		}
	        	}

	        	// console.log(response.data)
	        	this.user.Taoyu=response.data.taoyu;
	        	this.user.Huangyi=response.data.huangyi;
          //  console.log(response.data.daftar_kota.map(kota => kota.Taoyu))
	        	this.series = [
	        	{
	        		name: 'Taoyu',
		          	data: response.data.daftar_kota.map(kota => kota.Taoyu)
		        },{
		        	name: 'Huangyi',
		          	data: response.data.daftar_kota.map(kota => kota.HuangYi)
		        }]

            

	        	// this.options.categories
	        });
		}else{
			this.$router.push({name: 'Login'});
		}

	},
	methods: {
        onResize() {
          if (window.innerWidth < 769)
            this.isMobile = true;
          else
            this.isMobile = false;
        },
   	}
}
</script>

<style type="text/css">
.chart_dash {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 60%;
  height: 50%;
  background-color: yellow;
}


.mobile {
  color: #333;
}

@media screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid deeppink;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid cyan;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
  }
  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }
  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}
.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  padding: 5px;
  width: 50%;
  height: 40px;
  font-weight: bold;
}
</style>
